<template>
    <v-list>
        <template v-for="(itemOuLote, index) in resultados" class="pa-2">
            <v-divider :key="index"></v-divider>
                <v-list-tile :key="itemOuLote.id"  class="py-2 d-flex"
                              :inactive="!itemOuLote.existeTrocaDeMensagens"
                              @click="$emit('itemLoteClicked', itemOuLote)">
                    <v-list-tile-content>
                        <v-list-tile-title
                            class="primary--text text-uppercase font-weight-bold">
                            {{itemOuLote.loteItem}}
                            <span class="red--text text-capitalize ml-2" style="font-size: 0.8rem;">
                                {{(itemOuLote.existeTrocaDeMensagens ? '' : 'Não há mensagens')}}
                            </span>

                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                <span v-if="itemOuLote.totalMensagensNaoLidas > 0" class="p-quantidade-mensagens text-sm-center justify-center">
                    {{itemOuLote.totalMensagensNaoLidas}}
                </span>
                    </v-list-tile-action>
                    <v-list-tile-action>
                        <v-icon right size="20">fas fa-chevron-right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>
        </template>
    </v-list>
</template>

<script>
export default {
    name: 'ChatItemLoteFornecedor',
    props: {
        resultados: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .p-quantidade-mensagens
        height 25px !important
        width 25px !important
        max-width 25px !important
        border none
        background-color red
        color white
        text-align center !important
        align-content center !important
        font-size 0.7rem
        border-radius 25px
        -webkit-border-radius 25px

</style>